import React from "react";
import { Row, Col } from "react-bootstrap";
import CustomCard from "../../CustomCard";

import Leaflet from "../../../../assets/images/DigitalPrinting/Leaflet.png";
import Brochure from "../../../../assets/images/DigitalPrinting/Brochure.jpg";
import Catalogues from "../../../../assets/images/DigitalPrinting/Catalogues.jpg";

// Card Data
const cardData = [
  { image: Leaflet, text: "Leaflets" },
  { image: Brochure, text: "Brochures" },
  { image: Catalogues, text: "Catalogues" },
];

function HomeSection5() {
  return (
    <>
      <div className="mt-4 w-100 p-0">
        <h2 className="py-4 fw-bold text-center">Digital Printing</h2>

        <Row>
          {/* First row */}
          <Col md={4} className="d-flex">
            <CustomCard image={cardData[0].image} text={cardData[0].text} />
          </Col>
          <Col md={4} className="d-flex">
            <CustomCard image={cardData[1].image} text={cardData[1].text} />
          </Col>
          <Col md={4} className="d-flex">
            <CustomCard image={cardData[2].image} text={cardData[2].text} />
          </Col>
        </Row>
      </div>
    </>
  );
}

export default HomeSection5;
